
import React, { useRef } from "react";
import { Box, Button, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const CategoryBar = ({ allCategories, handleSelect, selectedCategory ,setPageCount}) => {
  const scrollRef = useRef(null);


  
    const filterByCategory = (category) => {
        return category?.filter((cat) => cat.parent === null);
    }

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = scrollRef.current.offsetWidth; // scroll by one "page"
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

 const handleSelectCategory = (cat) => {
  if (selectedCategory === cat) {
    handleSelect(null); 
  } else {
    // ✅ normal select
    handleSelect(cat);
  }
  setPageCount(0);
};


  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        width: "100%",
        overflow: "hidden",
        py: 2,
      }}
    >
      {/* Left Arrow */}
      <IconButton
        size="small"
        onClick={() => scroll("left")}
        sx={{
          boxShadow: 2,
          "&:hover": { bgcolor: "grey.100" },
        }}
      >
        <ArrowBackIosNewIcon fontSize="small" />
      </IconButton>

      {/* Scrollable Category Buttons */}
      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          overflowX: "auto",
          scrollbarWidth: "none", // Firefox
          "&::-webkit-scrollbar": { display: "none" }, // Chrome/Safari
          scrollBehavior: "smooth",
          flex: 1,
          py:2 // spacing so arrows don’t overlap text
        }}
      >
        {filterByCategory(allCategories)?.map((cat, idx) => (
          <Box
            key={idx}
            sx={{
              flex: "0 0 15%", // 🔑 ensures exactly 5 categories visible
              display: "flex",
              justifyContent: "center",
              px: 1,
            }}
          >
            <Button
              variant="contained"
              size="small"
              sx={{
                bgcolor: selectedCategory === cat?.name ? "black" : "white",
                color: selectedCategory === cat?.name ? "white" : "black",
                borderRadius: "10px",
                whiteSpace: "nowrap",
                textTransform: "none",
                width: "100%",
                "&:hover": {
                  bgcolor: selectedCategory === cat?.name ? "black" : "grey.100",
                },
              }}
              onClick={() => handleSelectCategory(cat?.name)}
            >
              {cat.name}
            </Button>
          </Box>
        ))}
      </Box>

      {/* Right Arrow */}
      <IconButton
        size="small"
        onClick={() => scroll("right")}
        sx={{
      
          boxShadow: 2,
          "&:hover": { bgcolor: "grey.100" },
        }}
      >
        <ArrowForwardIosIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default CategoryBar;
